// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var compare = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var OriginIsSymbol = {
    reflectSymbol: function () {
        return "Origin";
    }
};
var FulfillmentMethodIsSymbol = {
    reflectSymbol: function () {
        return "FulfillmentMethod";
    }
};
var PaymentMethodIsSymbol = {
    reflectSymbol: function () {
        return "PaymentMethod";
    }
};
var IsDividedIsSymbol = {
    reflectSymbol: function () {
        return "IsDivided";
    }
};
var ScheduleIsSymbol = {
    reflectSymbol: function () {
        return "Schedule";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var Origin = /* #__PURE__ */ (function () {
    function Origin() {

    };
    Origin.value = new Origin();
    return Origin;
})();
var FulfillmentMethod = /* #__PURE__ */ (function () {
    function FulfillmentMethod() {

    };
    FulfillmentMethod.value = new FulfillmentMethod();
    return FulfillmentMethod;
})();
var PaymentMethod = /* #__PURE__ */ (function () {
    function PaymentMethod() {

    };
    PaymentMethod.value = new PaymentMethod();
    return PaymentMethod;
})();
var IsDivided = /* #__PURE__ */ (function () {
    function IsDivided() {

    };
    IsDivided.value = new IsDivided();
    return IsDivided;
})();
var Schedule = /* #__PURE__ */ (function () {
    function Schedule(value0) {
        this.value0 = value0;
    };
    Schedule.create = function (value0) {
        return new Schedule(value0);
    };
    return Schedule;
})();
var toFillFormTypeInternalPar = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqInternalParameterId = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Origin && y instanceof Origin) {
                return true;
            };
            if (x instanceof FulfillmentMethod && y instanceof FulfillmentMethod) {
                return true;
            };
            if (x instanceof PaymentMethod && y instanceof PaymentMethod) {
                return true;
            };
            if (x instanceof IsDivided && y instanceof IsDivided) {
                return true;
            };
            if (x instanceof Schedule && y instanceof Schedule) {
                return eq(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var ordInternalParameterId = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Origin && y instanceof Origin) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Origin) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Origin) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof FulfillmentMethod && y instanceof FulfillmentMethod) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof FulfillmentMethod) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof FulfillmentMethod) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof PaymentMethod && y instanceof PaymentMethod) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof PaymentMethod) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof PaymentMethod) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof IsDivided && y instanceof IsDivided) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof IsDivided) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof IsDivided) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Schedule && y instanceof Schedule) {
                return compare(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterId (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqInternalParameterId;
    }
};
var genericInternalParameterId = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Origin.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return FulfillmentMethod.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return PaymentMethod.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return IsDivided.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return new Schedule(x.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterId (line 16, column 1 - line 16, column 93): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Origin) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof FulfillmentMethod) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof PaymentMethod) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof IsDivided) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Schedule) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.InternalParameterId (line 16, column 1 - line 16, column 93): " + [ x.constructor.name ]);
    }
};
var showInternalParameterId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericInternalParameterId)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(OriginIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(FulfillmentMethodIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PaymentMethodIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(IsDividedIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(ScheduleIsSymbol))))))
};
var unscrambleDecodeInternalParameterId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericInternalParameterId)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(OriginIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(FulfillmentMethodIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PaymentMethodIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(IsDividedIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ScheduleIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))))))))(Unscramble_Generic.defaultOptions)
};
var ufromJSONKeyInternalParameterId = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(unscrambleDecodeInternalParameterId)
};
var encodeInternalParameterId = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericInternalParameterId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OriginIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(FulfillmentMethodIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PaymentMethodIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(IsDividedIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ScheduleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))))))
};
var decodeInternalParameterId = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericInternalParameterId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OriginIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(FulfillmentMethodIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PaymentMethodIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(IsDividedIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ScheduleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(Foreign_Generic_Class.genericCountArgsArgument))))))
};
var asJSONKeyInternalParameterId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodeInternalParameterId), Foreign_Generic_Class.decode(decodeInternalParameterId))
    };
})();
export {
    Origin,
    FulfillmentMethod,
    PaymentMethod,
    IsDivided,
    Schedule,
    genericInternalParameterId,
    eqInternalParameterId,
    showInternalParameterId,
    asJSONKeyInternalParameterId,
    ufromJSONKeyInternalParameterId,
    ordInternalParameterId,
    encodeInternalParameterId,
    decodeInternalParameterId,
    unscrambleDecodeInternalParameterId,
    toFillFormTypeInternalPar
};
